import { LoadingButton } from "@mui/lab";
import {
  Button,
  Chip,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useUpdateAdmiredCompaniesMutation } from "../../services/profileAPI";
import { CustomDialogTitle } from "../../ui";

export const PROFILE_COMPANIES_ADMIRED_OPTIONS = [
  "coco cola",
  "zomato",
  "spotify",
  "netflix",
  "linkedin",
  "flipkart",
  "amazon",
  "uber",
  "apple",
  "swiggy",
  "ola",
  "mckinsey & company",
  "twitter",
  "hdfc",
  "citi",
  "goldman sachs",
  "cred",
  "times group",
  "ndtv",
  "wework",
  "google",
  "paytm",
  "samsung",
  "reliance",
  "bookmyshow",
  "house of anita dongre",
  "pvr",
  "sabyasachi",
  "chumbak",
  "hotstar",
  "sequoia capital",
  "american express",
  "tinder",
];

function EditAdmiredCompanies({ admiredCompanies, onClose }: any) {
  const [chosenValues, setChosenValues] = useState<string[]>(
    admiredCompanies.filter((eachCompany: string) =>
      PROFILE_COMPANIES_ADMIRED_OPTIONS.includes(eachCompany)
    )
  );

  const [
    updateAdmiredCompanies,
    { isLoading: isUpdateAdmiredCompaniesLoading },
  ] = useUpdateAdmiredCompaniesMutation();

  const { enqueueSnackbar } = useSnackbar();

  const onUpdateHandler = async () => {
    try {
      if (!chosenValues.length) {
        return enqueueSnackbar("please select atleast one company", {
          variant: "error",
        });
      }
      await updateAdmiredCompanies(chosenValues).unwrap();
      enqueueSnackbar("profile details updated!", {
        variant: "success",
      });
      onClose();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("failed to update your details", {
        variant: "error",
      });
    }
  };

  const onTagPress = (tag: string) => {
    if (chosenValues?.find((id) => id === tag)) {
      const newTags = chosenValues?.filter((id) => id !== tag);
      setChosenValues(newTags);
    } else {
      setChosenValues((prevValues) => [...prevValues, tag.toLowerCase()]);
    }
  };

  return (
    <>
      <CustomDialogTitle onClose={onClose}>
        <Typography>edit admired companies</Typography>
      </CustomDialogTitle>
      <DialogContent dividers>
        <Stack direction="row" flexWrap="wrap">
          {PROFILE_COMPANIES_ADMIRED_OPTIONS.map((tag) => {
            return (
              <Chip
                key={tag}
                label={tag}
                size="small"
                variant={
                  chosenValues?.find((id) => id === tag) ? "filled" : "outlined"
                }
                color={
                  chosenValues?.find((id) => id === tag) === tag
                    ? "primary"
                    : "default"
                }
                sx={{
                  mr: 1,
                  mb: 2,
                  fontSize: 12,
                  pl: 1.5,
                  pr: 1.5,
                  paddingTop: 1.7,
                  paddingBottom: 1.7,
                }}
                onClick={() => onTagPress(tag)}
              />
            );
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          cancel
        </Button>
        <LoadingButton
          variant="text"
          type="submit"
          loading={isUpdateAdmiredCompaniesLoading}
          onClick={onUpdateHandler}
        >
          update
        </LoadingButton>
      </DialogActions>
    </>
  );
}

export default EditAdmiredCompanies;
